import React from "react";
import { FaChild, FaClipboardCheck, FaSmile } from "react-icons/fa";

export default function MchatSection({ onStart }) {
  return (
    <section className="w-full py-12 px-4 bg-gradient-to-br from-sky-50 via-white to-indigo-50 rounded-xl shadow-lg my-8 animate-fadeIn" id="mchat-section" style={{ maxWidth: 900, margin: "2rem auto" }}>
      <h2 className="text-3xl md:text-4xl font-bold text-center text-sky-800 mb-3">Early Autism Screening</h2>
      <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 justify-center">
        <div className="flex-1 flex flex-col gap-4 items-center md:items-start">
          <div className="flex gap-2 text-3xl text-indigo-500 mb-2">
            <FaChild /> <FaClipboardCheck /> <FaSmile />
          </div>
          <p className="text-lg text-gray-700 mb-2 max-w-lg">
            <span className="font-semibold text-indigo-700">M-CHAT</span> (Modified Checklist for Autism in Toddlers) is a simple, research-backed screening tool for early signs of autism in children aged 16–30 months.
          </p>
          <ul className="list-disc pl-6 text-gray-600 text-base mb-2">
            <li>Quick, free, and easy to complete</li>
            <li>Helps parents and caregivers spot early signs</li>
            <li>Receive instant, private results</li>
          </ul>
          <button
            className="mt-3 px-6 py-3 bg-sky-600 hover:bg-sky-700 text-white font-bold rounded-lg shadow-lg text-lg transition"
            onClick={onStart}
          >
            Take the Free M-CHAT Screening
          </button>
        </div>
        <div className="flex-1 flex items-center justify-center">
          <img
            src={require("../assets/images/mchat-illustration.png")}
            alt="Illustration for M-CHAT autism screening"
            className="w-full max-w-xs md:max-w-sm rounded-xl shadow bg-gradient-to-br from-sky-50 to-indigo-50 object-contain"
            style={{ background: 'linear-gradient(135deg, #e0f7fa 0%, #f0e7ff 100%)' }}
          />
        </div>
      </div>
    </section>
  );
}
